import React, { useEffect, useRef, useState, useMemo } from "react";
import { Row, Col, Form, Button, Table, Modal } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { IoEyeOutline } from "react-icons/io5";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import InputField from "../../../components/input/input-field";
import CustomPhoneInput from "../../../components/input/phone-input";
import "react-phone-input-2/lib/style.css";
import Select, { components } from "react-select";
import FadeLoaderComponent from "../../../components/loader-component";
import { RxCross2 } from "react-icons/rx";
import { FaPlus } from "react-icons/fa";
import { roleTypes } from "../../../data/roleType";
import JobProducts from "../../../components/job-products";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";
import JobBomsList from "../../../components/job-bom-list";
import JobWorkOrders from "../../../components/JobWorkOrders";
import DatePickerField from "../../../components/input/date-picker-field";

const STATUS_OPTIONS = [
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Progress",
    value: "in-progress",
  },
  {
    label: "Completed",
    value: "completed",
  },
];

const CustomMenuList = ({ children, ...props }) => {
  const { selectProps } = props;
  const {
    isAddingNewType,
    setIsAddingNewType,
    setIsAddingNewContact,
    newTypeName,
    setNewTypeName,
    newTypeError,
    setNewTypeError,
    newTypeInputRef,
    isSubmittingNewType,
    handleSubmitNewType,
    handleCancelNewType,
    setOpenContactMenuIndex,
    setOpenSystemMenuIndex,
  } = selectProps;

  return (
    <components.MenuList {...props}>
      {!isAddingNewType ? (
        <>
          {children}
          <div
            style={{
              padding: "10px 12px",
              cursor: "pointer",
              backgroundColor: "#f8f9fa",
              borderTop: "1px solid #dee2e6",
              color: "#007bff",
              fontWeight: "500",
              textAlign: "center",
              transition: "background-color 0.2s",
              position: "sticky",
              bottom: -4,
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsAddingNewContact(false);
              setOpenContactMenuIndex(null);
              setOpenSystemMenuIndex(null);
              setIsAddingNewType(true);
              setNewTypeName("");
              setNewTypeError("");
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#e9ecef";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#f8f9fa";
            }}
          >
            + Add New Type
          </div>
        </>
      ) : (
        <div
          style={{
            padding: "12px",
            backgroundColor: "#fff",
            borderTop: "1px solid #dee2e6",
          }}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{
              marginBottom: "8px",
              fontSize: "13px",
              fontWeight: "600",
              color: "#495057",
            }}
          >
            Create New Type
          </div>
          <div style={{ display: "flex", gap: "6px", alignItems: "start" }}>
            <div style={{ flex: 1 }}>
              <input
                ref={newTypeInputRef}
                type="text"
                placeholder="Enter type name"
                value={newTypeName}
                onChange={(e) => {
                  setNewTypeName(e.target.value);
                  setNewTypeError("");
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmitNewType();
                  } else if (e.key === "Escape") {
                    e.preventDefault();
                    handleCancelNewType();
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewType}
                autoFocus
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: newTypeError
                    ? "1px solid #dc3545"
                    : "1px solid #ced4da",
                  borderRadius: "4px",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => {
                  if (!newTypeError) {
                    e.target.style.borderColor = "#007bff";
                  }
                }}
                onBlur={(e) => {
                  if (!newTypeError) {
                    e.target.style.borderColor = "#ced4da";
                  }
                }}
              />
              {newTypeError && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "6px",
                  }}
                >
                  {newTypeError}
                </div>
              )}
            </div>
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleSubmitNewType();
              }}
              disabled={isSubmittingNewType}
              style={{
                padding: "6px 12px",
                backgroundColor: isSubmittingNewType ? "#0d67c8ff" : "#28a745",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewType ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#218838";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#28a745";
                }
              }}
            >
              {isSubmittingNewType ? "..." : "✓"}
            </button>
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleCancelNewType();
              }}
              className="bg-danger"
              disabled={isSubmittingNewType}
              style={{
                padding: "6px 12px",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewType ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#5a6268";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewType) {
                  e.currentTarget.style.backgroundColor = "#6c757d";
                }
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </components.MenuList>
  );
};

const CustomContactMenuList = ({ children, ...props }) => {
  const { selectProps } = props;
  const {
    isAddingNewContact,
    setIsAddingNewContact,
    setIsAddingNewType,
    newContactData,
    setNewContactData,
    newContactError,
    setNewContactError,
    isSubmittingNewContact,
    handleSubmitNewContact,
    handleCancelNewContact,
    hasCreateStakeholderPermission,
    isSuperAdmin,
    setOpenTypeMenuIndex,
    setOpenSystemMenuIndex,
    displayButton,
  } = selectProps;
  const canAddContact = hasCreateStakeholderPermission || isSuperAdmin;

  return (
    <components.MenuList {...props}>
      {!isAddingNewContact ? (
        <>
          {children}
          {canAddContact && displayButton && (
            <div
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #dee2e6",
                color: "#007bff",
                fontWeight: "500",
                textAlign: "center",
                transition: "background-color 0.2s",
                position: "sticky",
                bottom: -4,
                zIndex: 1,
              }}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsAddingNewType(false);
                setOpenTypeMenuIndex(null);
                setOpenSystemMenuIndex(null);
                setIsAddingNewContact(true);
                setNewContactData({
                  name: "",
                  phone_number: "",
                  email: "",
                  title: "",
                });
                setNewContactError("");
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e9ecef";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
              }}
            >
              + Add New Contact
            </div>
          )}
        </>
      ) : (
        displayButton && (
          <div
            style={{
              padding: "12px",
              backgroundColor: "#fff",
              borderTop: "1px solid #dee2e6",
            }}
          >
            <div
              style={{
                marginBottom: "8px",
                fontSize: "13px",
                fontWeight: "600",
                color: "#495057",
              }}
            >
              Create New Contact
            </div>
            <Form.Group className="form-group mb-1">
              <Form.Label style={{ fontSize: "14px", fontWeight: "600" }}>
                Contact Name
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={newContactData.name}
                onChange={(e) => {
                  setNewContactData({
                    ...newContactData,
                    name: e.target.value,
                  });
                  setNewContactError("");
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewContact}
                autoFocus
                style={{
                  fontSize: "14px",
                }}
              />
            </Form.Group>
            <Form.Group className="form-group mb-1">
              <Form.Label
                htmlFor="newContactPhone"
                style={{ fontSize: "14px", fontWeight: "600" }}
              >
                Phone Number
                <span className="text-danger">*</span>
              </Form.Label>
              <div
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
              >
                <CustomPhoneInput
                  id="newContactPhone"
                  name="newContactPhone"
                  value={newContactData.phone_number}
                  onChange={(value) => {
                    setNewContactData({
                      ...newContactData,
                      phone_number: value,
                    });
                    setNewContactError("");
                  }}
                  disabled={isSubmittingNewContact}
                  placeholder="Enter phone number"
                  country="us"
                />
              </div>
            </Form.Group>

            {newContactError && (
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "12px",
                  marginTop: "6px",
                }}
              >
                {newContactError}
              </div>
            )}
            <div
              style={{
                display: "flex",
                gap: "6px",
                justifyContent: "flex-end",
                marginTop: "4px",
              }}
            >
              <button
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleSubmitNewContact();
                }}
                disabled={isSubmittingNewContact}
                style={{
                  padding: "6px 12px",
                  backgroundColor: isSubmittingNewContact
                    ? "#0d67c8ff"
                    : "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: isSubmittingNewContact ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  fontWeight: "bold",
                  minWidth: "36px",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#218838";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#28a745";
                  }
                }}
              >
                {isSubmittingNewContact ? "..." : "✓"}
              </button>
              <button
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleCancelNewContact();
                }}
                className="bg-danger"
                disabled={isSubmittingNewContact}
                style={{
                  padding: "6px 12px",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: isSubmittingNewContact ? "not-allowed" : "pointer",
                  fontSize: "16px",
                  fontWeight: "bold",
                  minWidth: "36px",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#5a6268";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSubmittingNewContact) {
                    e.currentTarget.style.backgroundColor = "#6c757d";
                  }
                }}
              >
                ✕
              </button>
            </div>
          </div>
        )
      )}
    </components.MenuList>
  );
};
const CustomSystemMenuList = ({ children, ...props }) => {
  const { selectProps } = props;
  const {
    isAddingNewSystem,
    setIsAddingNewSystem,
    setIsAddingNewContact,
    setIsAddingNewType,
    newSystemData,
    setNewSystemData,
    newSystemError,
    setNewSystemError,
    isSubmittingNewSystem,
    handleSubmitNewSystem,
    handleCancelNewSystem,
    hasCreateSystemPermission,
    hasCreatePhasePermission,
    isSuperAdmin,
    setOpenTypeMenuIndex,
    setOpenContactMenuIndex,
  } = selectProps;
  const canAddSystem =
    hasCreateSystemPermission || hasCreatePhasePermission || isSuperAdmin;

  return (
    <components.MenuList {...props}>
      {!isAddingNewSystem ? (
        <>
          {children}
          {canAddSystem && (
            <div
              style={{
                padding: "10px 12px",
                cursor: "pointer",
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #dee2e6",
                color: "#007bff",
                fontWeight: "500",
                textAlign: "center",
                transition: "background-color 0.2s",
                position: "sticky",
                bottom: -4,
                zIndex: 1,
              }}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsAddingNewContact(false);
                setIsAddingNewType(false);
                setOpenTypeMenuIndex(null);
                setOpenContactMenuIndex(null);
                setIsAddingNewSystem(true);
                setNewSystemData({ name: "", phases: "" });
                setNewSystemError("");
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e9ecef";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
              }}
            >
              + Add New System
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            padding: "12px",
            backgroundColor: "#fff",
            borderTop: "1px solid #dee2e6",
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{
              marginBottom: "8px",
              fontSize: "13px",
              fontWeight: "600",
              color: "#495057",
            }}
          >
            Create New System
          </div>
          <div style={{ marginBottom: "8px" }}>
            <Form.Group className="form-group mb-1">
              <Form.Label
                htmlFor="newSystemName"
                style={{ fontSize: "14px", fontWeight: "600" }}
              >
                System Name
                <span className="text-danger">*</span>
              </Form.Label>
              <input
                type="text"
                id="newSystemName"
                name="newSystemName"
                placeholder="Enter system name"
                value={newSystemData.name}
                onChange={(e) => {
                  setNewSystemData({ ...newSystemData, name: e.target.value });
                  setNewSystemError("");
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSubmitNewSystem();
                  } else if (e.key === "Escape") {
                    e.preventDefault();
                    handleCancelNewSystem();
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewSystem}
                autoFocus
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: newSystemError
                    ? "1px solid #dc3545"
                    : "1px solid #ced4da",
                  borderRadius: "4px",
                  fontSize: "14px",
                  outline: "none",
                  transition: "border-color 0.2s",
                }}
                onFocus={(e) => {
                  if (!newSystemError) {
                    e.target.style.borderColor = "#007bff";
                  }
                }}
                onBlur={(e) => {
                  if (!newSystemError) {
                    e.target.style.borderColor = "#ced4da";
                  }
                }}
              />
            </Form.Group>
          </div>
          <div style={{ marginBottom: "8px" }}>
            <Form.Group className="form-group mb-1">
              <Form.Label
                htmlFor="newSystemPhases"
                style={{ fontSize: "14px", fontWeight: "600" }}
              >
                Phases (comma-separated)
                <span className="text-danger">*</span>
              </Form.Label>
              <textarea
                rows={2}
                id="newSystemPhases"
                name="newSystemPhases"
                className="form-control"
                value={newSystemData.phases}
                onChange={(e) => {
                  setNewSystemData({
                    ...newSystemData,
                    phases: e.target.value,
                  });
                  setNewSystemError("");
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                  if (e.key === "Escape") {
                    e.preventDefault();
                    handleCancelNewSystem();
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
                onMouseUp={(e) => {
                  e.stopPropagation();
                }}
                disabled={isSubmittingNewSystem}
                placeholder="e.g. Phase 1, Phase 2, Phase 3"
                style={{
                  fontSize: "14px",
                  resize: "none",
                }}
              />
            </Form.Group>
          </div>
          {newSystemError && (
            <div
              style={{
                color: "#dc3545",
                fontSize: "12px",
                marginBottom: "8px",
              }}
            >
              {newSystemError}
            </div>
          )}
          <div
            style={{ display: "flex", gap: "6px", justifyContent: "flex-end" }}
          >
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleSubmitNewSystem();
              }}
              className="bg-success"
              disabled={isSubmittingNewSystem}
              style={{
                padding: "6px 12px",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewSystem ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#218838";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#28a745";
                }
              }}
            >
              {isSubmittingNewSystem ? "..." : "✓"}
            </button>
            <button
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleCancelNewSystem();
              }}
              className="bg-danger"
              disabled={isSubmittingNewSystem}
              style={{
                padding: "6px 12px",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: isSubmittingNewSystem ? "not-allowed" : "pointer",
                fontSize: "16px",
                fontWeight: "bold",
                minWidth: "36px",
                transition: "background-color 0.2s",
              }}
              onMouseEnter={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#5a6268";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmittingNewSystem) {
                  e.currentTarget.style.backgroundColor = "#6c757d";
                }
              }}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </components.MenuList>
  );
};

const JobEdit = () => {
  const alertRef = useRef(null);
  const navigate = useNavigate();
  const [job, setJob] = useState();
  const { id } = useParams();
  const [loader, setLoader] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [errors, setErrors] = useState({});
  const [decodedToken, setDecodedToken] = useState();
  const [contacts, setContacts] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [systems, setSystems] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [stakeholderTypeOptions, setStakeholderTypeOptions] = useState([]);
  const [isAddingNewType, setIsAddingNewType] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const [newTypeError, setNewTypeError] = useState("");
  const [isSubmittingNewType, setIsSubmittingNewType] = useState(false);
  const [systemPhasesMap, setSystemPhasesMap] = useState({});
  const [allContacts, setAllContacts] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isCompleted, setIsCompleted] = useState(false);
  const [jobData, setJobData] = useState({});
  const permissions = useSelector(SettingSelector.set_permissions);
  const hasUpdatePermission = permissions?.job?.update === true;
  const hasViewPermission = permissions?.job?.view === true;
  const hasViewJobProductReortPermission =
    permissions?.job?.view_job_product_report === true;
  const hasUpdateJobItemStatusPermission =
    permissions?.job?.update_job_item_status === true;

  const hasBomCreatePermission = permissions?.job?.create_bom === true;
  const hasBomViewPermission = permissions?.job?.view_bom === true;
  const hasBomEditPermission = permissions?.job?.edit_bom === true;
  const hasBomDeletePermission = permissions?.job?.delete_bom === true;
  const hasBomCreatePRPermission = permissions?.job?.create_bom_pr === true;
  const hasBomPrintPermission = permissions?.job?.print_bom === true;
  const hasCreateStakeholderPermission =
    permissions?.stakeholder?.update === true;
  const hasCreateSystemPermission = permissions?.system?.create === true;
  const hasCreatePhasePermission = permissions?.phase?.create === true;
  const isSuperAdmin = decodedToken?.roles?.some(
    (role) => role.role_type === roleTypes.SUPER_ADMIN
  );

  const token = localStorage.getItem("coyote-token");
  const newTypeInputRef = useRef(null);
  const allContactsRef = useRef({});
  const [openTypeMenuIndex, setOpenTypeMenuIndex] = useState(null);
  const [contactsLoadingMap, setContactsLoadingMap] = useState({});
  const [hasLoadedContactsMap, setHasLoadedContactsMap] = useState({});

  const [isAddingNewContact, setIsAddingNewContact] = useState(false);
  const [newContactData, setNewContactData] = useState({
    name: "",
    phone_number: "",
  });
  const [newContactError, setNewContactError] = useState("");
  const [isSubmittingNewContact, setIsSubmittingNewContact] = useState(false);
  const [openContactMenuIndex, setOpenContactMenuIndex] = useState(null);

  const [isAddingNewSystem, setIsAddingNewSystem] = useState(false);
  const [newSystemData, setNewSystemData] = useState({ name: "", phases: "" });
  const [newSystemError, setNewSystemError] = useState("");
  const [isSubmittingNewSystem, setIsSubmittingNewSystem] = useState(false);
  const [openSystemMenuIndex, setOpenSystemMenuIndex] = useState(null);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);
  const [isSubmitInProgress, setIsSubmitInProgress] = useState(false);
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });

  const [collapsedSections, setCollapsedSections] = useState(() => {
    const isSuperAdmin = decodedToken?.roles?.some(
      (role) => role.role_type === roleTypes.SUPER_ADMIN
    );

    const hasJobProductsPermission =
      permissions?.job?.update_job_item_status === true ||
      permissions?.job?.view_job_product_report === true;

    const hasBomPermissions =
      permissions?.job?.create_bom === true ||
      permissions?.job?.view_bom === true ||
      permissions?.job?.edit_bom === true ||
      permissions?.job?.delete_bom === true ||
      permissions?.job?.create_bom_pr === true ||
      permissions?.job?.print_bom === true;

    return {
      jobInfo: true,
      jobWorkorders: false,
      jobProducts: hasJobProductsPermission ? false : true,
      jobBoms: isSuperAdmin
        ? false
        : !hasJobProductsPermission && hasBomPermissions
        ? false
        : true,
    };
  });

  useEffect(() => {
    const isSuperAdmin = decodedToken?.roles?.some(
      (role) => role.role_type === roleTypes.SUPER_ADMIN
    );

    const hasJobProductsPermission =
      permissions?.job?.update_job_item_status === true ||
      permissions?.job?.view_job_product_report === true;

    const hasBomPermissions =
      permissions?.job?.create_bom === true ||
      permissions?.job?.view_bom === true ||
      permissions?.job?.edit_bom === true ||
      permissions?.job?.delete_bom === true ||
      permissions?.job?.create_bom_pr === true ||
      permissions?.job?.print_bom === true;

    setCollapsedSections({
      jobInfo: true,
      jobWorkorders: true,
      jobProducts: isSuperAdmin
        ? false
        : hasJobProductsPermission
        ? false
        : true,
      jobBoms: !hasJobProductsPermission && hasBomPermissions ? false : true,
    });
  }, [permissions, decodedToken]);

  const toggleCollapse = (section) => {
    setCollapsedSections((prev) => {
      if (!prev[section]) {
        return {
          ...prev,
          [section]: !prev[section],
        };
      }

      return {
        jobInfo: section !== "jobInfo",
        jobWorkorders: section !== "jobWorkorders",
        jobProducts: section !== "jobProducts",
        jobBoms: section !== "jobBoms",
      };
    });
  };

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getSystems = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(`${url.backendURL}system/all`, config);
      setSystems(response.data.response.data);
    } catch (err) {
      handleError(err, "job-edit");
    }
  };

  const getStakeholders = async () => {
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
        params: {
          id: id,
        },
      };
      const response = await axios.get(
        `${url.backendURL}stakeholder/all`,
        config
      );
      setStakeholders(response.data.response.data);
    } catch (err) {
      handleError(err, "job-edit");
    }
  };

  const getContacts = async (stakeholderId, index) => {
    if (allContactsRef.current[stakeholderId]) {
      return allContactsRef.current[stakeholderId];
    }
    setContactsLoadingMap((prev) => ({ ...prev, [index]: true }));

    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(
        `${url.backendURL}stakeholder/${stakeholderId}/contacts`,
        config
      );
      const contactsData = response.data.response.data || [];
      allContactsRef.current[stakeholderId] = contactsData;
      setAllContacts((prev) => ({
        ...prev,
        [stakeholderId]: contactsData,
      }));
      setHasLoadedContactsMap((prev) => ({ ...prev, [stakeholderId]: true }));

      return contactsData;
    } catch (err) {
      console.error("Error fetching contacts:", err);
      return [];
    } finally {
      setContactsLoadingMap((prev) => {
        const newMap = { ...prev };
        delete newMap[index];
        return newMap;
      });
    }
  };

  const getAvailableTypeOptions = (stakeholderId, currentIndex, values) => {
    if (!stakeholderId) return stakeholderTypeOptions;
    const normalize = (val) =>
      val === undefined || val === null ? "" : String(val).trim();

    const usedTypes = values.contacts
      .map((contact, idx) =>
        idx !== currentIndex && contact.stakeholderId === stakeholderId
          ? normalize(contact.type)
          : null
      )
      .filter((type) => type && type !== "");

    return stakeholderTypeOptions.filter(
      (option) => !usedTypes.includes(normalize(option.value))
    );
  };

  const [isSubmitSystem, setIsSubmitSystem] = useState({});

  const getPhases = async (productSystemId, systemIndex = null) => {
    try {
      if (systemIndex !== null) {
        setIsSubmitSystem((prev) => ({ ...prev, [systemIndex]: true }));
      }
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(
        `${url.backendURL}product/system/${productSystemId}/phase`,
        config
      );
      if (systemIndex !== null) {
        setIsSubmitSystem((prev) => ({ ...prev, [systemIndex]: false }));
      }
      return response.data.response.data;
    } catch (err) {
      if (systemIndex !== null) {
        setIsSubmitSystem((prev) => ({ ...prev, [systemIndex]: false }));
      }
      handleError(err, "job-edit");
      return [];
    }
  };

  const getJob = async () => {
    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };

    try {
      const response = await axios.get(
        `${url.backendURL}job/${id}/detail`,
        config
      );
      const jobData = response.data.response.data;
      setJobData(jobData);

      const transformedContacts = jobData.stakeholders.map((stakeholder) => ({
        stakeholderId: stakeholder.stakeholder_id,
        contactId: stakeholder.contact_id,
        type: stakeholder.type || "",
      }));

      const isJobCompleted = jobData.job_status === "completed";
      const isJobInfoClosed = ["closed", "in-active"].includes(
        (jobData.status || "").toLowerCase()
      );
      setIsCompleted(isJobCompleted || isJobInfoClosed);
      const transformedSystems =
        jobData.systems?.map((system) => ({
          systemId: system.system_id,
          phases: system.phase_ids || [],
        })) || [];

      setJob({
        name: jobData.name,
        location: jobData.location,
        estimate: jobData.estimate,
        bidDate: jobData.bid_date.split("T")[0],
        jobStatus: jobData.job_status,
        siteName: jobData.site_name,
        systems: transformedSystems,
        activeSystemId: jobData.active_system_id,
        activePhaseId: jobData.active_phase_id,
        area: jobData.area && jobData.area.length > 0 ? jobData.area : [""],
        contacts: transformedContacts,
      });

      const phasesMap = {};
      for (const system of transformedSystems) {
        if (system.systemId) {
          const fetchedPhases = await getPhases(system.systemId);
          phasesMap[system.systemId] = fetchedPhases;
        }
      }
      setSystemPhasesMap(phasesMap);

      const uniqueStakeholderIds = [
        ...new Set(jobData.stakeholders.map((s) => s.stakeholder_id)),
      ];
      for (const stakeholderId of uniqueStakeholderIds) {
        await getContacts(stakeholderId);
      }

      return jobData;
    } catch (err) {
      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "information");
      throw err;
    }
  };

  useEffect(() => {
    if (token && decodedToken) {
      const fetchAllData = async () => {
        try {
          setLoader(true);
          setDataLoaded(false);

          const jobData = await getJob();
          await getSystems();
          if (jobData.status !== "closed") {
            await Promise.all([getStakeholders(), fetchStakeholderTypes()]);
          }

          setDataLoaded(true);
        } catch (err) {
          console.error("Error loading data:", err);
        } finally {
          setLoader(false);
        }
      };

      fetchAllData();
    }
  }, [token, decodedToken]);

  const createContact = async (stakeholderId, contactData) => {
    setIsSubmittingNewContact(true);
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.post(
        `${url.backendURL}stakeholder/${stakeholderId}/contacts`,
        contactData,
        config
      );
      const newContact = response.data.response.data;

      setAllContacts((prev) => {
        const existingContacts = prev[stakeholderId] || [];
        return {
          ...prev,
          [stakeholderId]: [...existingContacts, newContact],
        };
      });

      setContacts((prev) => [...prev, newContact]);

      return { success: true, data: newContact };
    } catch (err) {
      setNewContactError(
        err?.response?.data?.message || "Failed to create contact"
      );
      return { success: false };
    } finally {
      setIsSubmittingNewContact(false);
    }
  };

  const handleSubmitNewContact = async (
    setFieldValue,
    index,
    stakeholderId
  ) => {
    if (!newContactData.name || !newContactData.name.trim()) {
      setNewContactError("Name is required");
      return;
    }
    const nameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9 '&.-]*$/;
    if (!nameRegex.test(newContactData.name)) {
      setNewContactError("Invalid name format");
      return;
    }

    if (!newContactData.phone_number || !newContactData.phone_number.trim()) {
      setNewContactError("Phone number is required");
      return;
    }
    if (newContactData.phone_number.length < 10) {
      setNewContactError("Phone number must be at least 10 digits");
      return;
    }

    if (!stakeholderId) {
      setNewContactError("Stakeholder not selected");
      return;
    }

    const res = await createContact(stakeholderId, newContactData);
    if (res.success && res.data) {
      setIsAddingNewContact(false);
      setNewContactData({ name: "", phone_number: "" });
      setNewContactError("");
      setOpenContactMenuIndex(null);
      if (typeof setFieldValue === "function") {
        setFieldValue(`contacts.${index}.contactId`, res.data.id);
      }
    }
  };

  const handleCancelNewContact = () => {
    setIsAddingNewContact(false);
    setNewContactData({ name: "", phone_number: "" });
    setNewContactError("");
    setOpenContactMenuIndex(null);
  };

  const createSystemWithPhases = async (systemData) => {
    setIsSubmittingNewSystem(true);
    try {
      const config = { headers: { Authorization: `${token}` } };

      const phasesArray = systemData.phases
        ? systemData.phases
            .split(",")
            .map((phase) => phase.trim())
            .filter((phase) => phase.length > 0)
            .map((phase) => ({ name: phase }))
        : [];

      const response = await axios.post(
        `${url.backendURL}system/phases`,
        {
          name: systemData.name,
          phases: phasesArray,
        },
        config
      );
      return { success: true, data: response.data.response.data };
    } catch (err) {
      if (err?.response?.status === 409) {
        setNewSystemError(
          err?.response?.data?.message || "System with this name already exists"
        );
        return { success: false, error: "exists" };
      }
      setNewSystemError(
        err?.response?.data?.message || "Failed to create system with phases"
      );
      return { success: false };
    } finally {
      setIsSubmittingNewSystem(false);
    }
  };

  const handleSubmitNewSystem = async (setFieldValue, index) => {
    if (!newSystemData.name || !newSystemData.name.trim()) {
      setNewSystemError("System name is required");
      return;
    }
    if (!newSystemData.phases || !newSystemData.phases.trim()) {
      setNewSystemError("At least one phase is required");
      return;
    }

    setNewSystemError("");
    const result = await createSystemWithPhases(newSystemData);

    if (result.success && result.data) {
      const systemId = result.data.system.id;
      const allPhases = [
        ...result.data.phases.created,
        ...result.data.phases.existing,
      ];

      await getSystems();

      const fetchedPhases = await getPhases(systemId, index);
      setSystemPhasesMap((prev) => ({
        ...prev,
        [systemId]: fetchedPhases,
      }));

      setIsAddingNewSystem(false);
      setNewSystemData({ name: "", phases: "" });
      setOpenSystemMenuIndex(null);

      if (typeof setFieldValue === "function") {
        setFieldValue(`systems.${index}.systemId`, systemId);
        const phaseIds = fetchedPhases.map((p) => p.id);
        setFieldValue(`systems.${index}.phases`, phaseIds);

        setTimeout(() => {
          if (index === 0 || !jobData.activeSystemId) {
            setFieldValue("activeSystemId", systemId);
            setFieldValue("activePhaseId", phaseIds[0] || null);
          }
        }, 0);
      }
    }
  };

  const handleCancelNewSystem = () => {
    setIsAddingNewSystem(false);
    setNewSystemData({ name: "", phases: "" });
    setNewSystemError("");
    setOpenSystemMenuIndex(null);
  };

  useEffect(() => {
    if (isAddingNewType && newTypeInputRef.current) {
      setTimeout(() => {
        newTypeInputRef.current?.focus();
      }, 100);
    }
  }, [isAddingNewType]);

  useEffect(() => {
    allContactsRef.current = allContacts;
  }, [allContacts]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    if (values.jobStatus === "completed") {
      setPendingValues({ values, setSubmitting, resetForm });
      setShowConfirmModal(true);
      setSubmitting(false);
      return;
    }

    await submitForm(values, setSubmitting, resetForm);
  };

  const submitForm = async (values, setSubmitting, resetForm) => {
    setSubmitting(true);
    setIsSubmitInProgress(true);
    try {
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };

      const formattedSystems = values.systems.map((sys) => ({
        systemId: sys.systemId,
        phaseIds: sys.phases,
      }));

      const filteredAreas = values.area
        .map((area) => area.trim())
        .filter((area) => area.length > 0);

      const submitData = {
        ...values,
        systems: formattedSystems,
        area: filteredAreas,
      };

      const response = await axios.put(
        `${url.backendURL}job/${id}`,
        submitData,
        config
      );

      if (alertRef.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      setAlert({
        message: response.data.message,
        type: "success",
        show: true,
        alertFor: "job-edit",
      });
      await getJob();
      setErrors({});
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 2000);
    } catch (err) {
      handleError(err, "job-edit");
    } finally {
      setSubmitting(false);
      setIsSubmitInProgress(false);
    }
  };

  const handleConfirmCompleted = async () => {
    setShowConfirmModal(false);
    if (pendingValues) {
      await submitForm(
        pendingValues.values,
        pendingValues.setSubmitting,
        pendingValues.resetForm
      );
      setPendingValues(null);
    }
  };

  const handleCancelCompleted = () => {
    setShowConfirmModal(false);
    setPendingValues(null);
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (
      response.data.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN
          )
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  const validationSchema = () =>
    Yup.object().shape({
      name: Yup.string()
        .trim()
        .min(2, "Project name must be at least 2 characters long")
        .max(70, "Project name must not exceed 70 characters")
        .test(
          "starts-with-letter",
          "Project name must start with a letter",
          (value) => {
            if (!value) return false;
            return /^[a-zA-Z]/.test(value);
          }
        )
        .required("Project name is required"),
      location: Yup.string()
        .matches(
          /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
          "Address must contain at least one letter or number"
        )
        .min(2, "Address must be at least 2 characters long")
        .max(255, "Address must not exceed 255 characters")
        .trim()
        .nullable()
        .notRequired(),
      estimate: Yup.number()
        .nullable()
        .transform((value, originalValue) => {
          const trimmed = String(originalValue ?? "").trim();

          if (trimmed === "") return null;
          let formatted = trimmed;
          if (formatted.startsWith(".")) formatted = "0" + formatted;
          if (formatted.endsWith(".")) formatted = formatted.slice(0, -1);

          const num = Number(formatted);
          if (isNaN(num)) return null;
          return Math.round(num * 100) / 100;
        })
        .typeError("Estimate must be a number")
        .min(0, "Estimate must be positive")
        .test(
          "max-digits",
          "Estimate must have a maximum of 2 decimal places",
          (value) => {
            if (value === null || value === undefined) return true;
            return /^\d{1,12}(\.\d{1,2})?$/.test(value.toString());
          }
        )
        .notRequired(),
      bidDate: Yup.date()
        .required("Start date is required")
        .typeError("Start date must be a valid date"),
      jobStatus: Yup.string()
        .required("Job status is required")
        .oneOf(["in-progress", "pending", "completed"], "Invalid job status"),
      siteName: Yup.string()
        .trim()
        .matches(/^[^\d]/, "Site name must not start with a number")
        .min(2, "Site name must be at least 2 character long")
        .max(255, "Site name must not exceed 255 characters")
        .required("Site name is required"),
      contacts: Yup.array()
        .of(
          Yup.object().shape({
            stakeholderId: Yup.number()
              .integer("Stakeholder is required")
              .typeError("Stakeholder is invalid")
              .required("Stakeholder is required"),
            contactId: Yup.number()
              .nullable()
              .optional()
              .integer("Contact must be valid")
              .typeError("Contact is invalid"),
            type: Yup.string().trim().required("Type is required"),
          })
        )
        .min(1, "At least one stakeholder is required")
        .required("Stakeholders are required")
        .test(
          "unique-contacts",
          "Duplicate stakeholder, type, and contact combination not allowed",
          function (value) {
            if (!value) return true;
            const combinations = value.map(
              (v) =>
                `${v.stakeholderId || ""}-${v.type || ""}-${
                  v.contactId || "null"
                }`
            );
            const unique = new Set(combinations);
            if (unique.size < combinations.length) {
              return this.createError({
                message:
                  "Duplicate stakeholder, type, and contact combination not allowed",
              });
            }
            return true;
          }
        ),
      systems: Yup.array()
        .of(
          Yup.object().shape({
            systemId: Yup.number()
              .integer()
              .required("System is required")
              .typeError("System must be valid"),
            phases: Yup.array()
              .of(Yup.number().integer().required("Phase must be valid"))
              .min(1, "At least one phase is required")
              .required("Phases are required"),
          })
        )
        .min(1, "At least one system is required")
        .required("Systems are required"),
      activeSystemId: Yup.number()
        .integer()
        .required("Active system is required")
        .test(
          "is-in-systems",
          "Active system must be one of the selected systems",
          function (value) {
            const { systems } = this.parent;
            return systems?.some((sys) => sys.systemId === value);
          }
        ),
      activePhaseId: Yup.number()
        .integer()
        .required("Active phase is required")
        .test(
          "is-in-current-system-phases",
          "Active phase must belong to the selected system",
          function (value) {
            const { systems, activeSystemId } = this.parent;
            const currentSystem = systems?.find(
              (sys) => sys.systemId === activeSystemId
            );
            return currentSystem?.phases?.includes(value);
          }
        ),
      area: Yup.array()
        .of(
          Yup.string()
            .trim()
            .test(
              "not-only-numbers",
              "Area cannot be only numbers",
              (value) => {
                if (!value) return true;
                return !/^\d+$/.test(value);
              }
            )
        )
        .optional(),
    });

  const [optionsSystem, setOptionsSystem] = useState([]);

  const systemOptionsMemo = useMemo(() => {
    if (systems.length === 0) return [];
    return systems.map((system) => ({
      value: system.id,
      label: system.name,
    }));
  }, [systems]);

  useEffect(() => {
    setOptionsSystem(systemOptionsMemo);
  }, [systemOptionsMemo]);

  useEffect(() => {
    fetchStakeholderTypes();
  }, []);

  useEffect(() => {
    if (isAddingNewType && newTypeInputRef.current) {
      setTimeout(() => {
        newTypeInputRef.current?.focus();
      }, 100);
    }
  }, [isAddingNewType]);

  const [optionsJobStatus, setOptionsJobStatus] = useState(() => {
    return STATUS_OPTIONS.map((status) => ({
      value: status.value,
      label: status.label,
    }));
  });

  const [optionsStakeholder, setOptionsStakeholder] = useState([]);

  const stakeholderOptionsMemo = useMemo(() => {
    if (
      stakeholders.length === 0 &&
      (jobData?.stakeholders?.length ?? 0) === 0
    ) {
      return [];
    }
    const flatOptions = [];

    stakeholders.forEach((group) => {
      group.stakeholders.forEach((stakeholder) => {
        flatOptions.push({
          value: stakeholder.id,
          label: stakeholder.name,
          type: group.type,
        });
      });
    });

    if (jobData?.stakeholders?.length) {
      jobData.stakeholders.forEach((st) => {
        const exists = flatOptions.some(
          (opt) => opt.value === st.stakeholder_id
        );
        if (!exists) {
          flatOptions.push({
            value: st.stakeholder_id,
            label: st.stakeholder_name || `Stakeholder ${st.stakeholder_id}`,
            type: st.type || "",
          });
        }
      });
    }

    return flatOptions;
  }, [stakeholders, jobData]);

  useEffect(() => {
    setOptionsStakeholder(stakeholderOptionsMemo);
  }, [stakeholderOptionsMemo]);

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#007bff" : "#dee2e6",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(0, 123, 255, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#007bff",
      },
      minHeight: "38px",
      backgroundColor: "#fff",
    }),
  };

  const fetchStakeholderTypes = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const res = await axios.get(`${url.backendURL}stakeholder/types`, config);
      const types = res.data.response.data || [];
      setStakeholderTypeOptions(
        types.map((t) => ({ value: t.name, label: t.name }))
      );
    } catch (err) {}
  };

  const createStakeholderType = async (name) => {
    setIsSubmittingNewType(true);
    try {
      const config = { headers: { Authorization: `${token}` } };
      await axios.post(`${url.backendURL}stakeholder/types`, { name }, config);
      setStakeholderTypeOptions((prev) => [
        ...prev,
        { value: name, label: name },
      ]);
      setNewTypeName("");
      setNewTypeError("");
      return { success: true };
    } catch (err) {
      if (err?.response?.status === 409) {
        await fetchStakeholderTypes();
        setNewTypeError(
          err?.response?.data?.message || "Stakeholder type already exists"
        );
        return { success: false };
      }
      setNewTypeError(err?.response?.data?.message || "Failed to create type");
      return { success: false };
    } finally {
      setIsSubmittingNewType(false);
    }
  };

  const handleSubmitNewType = async (setFieldValue, fieldName) => {
    const name = newTypeName.trim();
    if (!name) {
      setNewTypeError("Type name is required");
      return;
    }
    const res = await createStakeholderType(name);
    if (res.success) {
      setIsAddingNewType(false);
      if (typeof setFieldValue === "function" && fieldName) {
        setFieldValue(fieldName, name);
      }
      setOpenTypeMenuIndex(null);
    }
  };

  const handleCancelNewType = () => {
    setIsAddingNewType(false);
    setNewTypeName("");
    setNewTypeError("");
    setOpenTypeMenuIndex(null);
  };

  const getContactOptionsForStakeholder = (stakeholderId) => {
    const stakeholderContacts = allContacts[stakeholderId] || [];
    return stakeholderContacts.map((contact) => ({
      value: contact.id,
      label: contact.name,
      email: contact.email,
      phone: contact.phone_number,
    }));
  };

  const getAvailableSystemOptions = (selectedSystems, currentIndex) => {
    const selectedSystemIds = selectedSystems
      .map((sys, idx) => (idx !== currentIndex ? sys.systemId : null))
      .filter((id) => id !== null);

    return systems
      .filter((system) => !selectedSystemIds.includes(system.id))
      .map((system) => ({
        value: system.id,
        label: system.name,
      }));
  };

  const getActiveSystemOptions = (selectedSystems) => {
    return selectedSystems
      .filter((sys) => sys.systemId !== null)
      .map((sys) => {
        const systemData = systems.find((s) => s.id === sys.systemId);
        return {
          value: sys.systemId,
          label: systemData?.name || `System ${sys.systemId}`,
        };
      });
  };

  const getActivePhaseOptions = (selectedSystems, activeSystemId) => {
    if (!activeSystemId) return [];
    const activeSystem = selectedSystems.find(
      (sys) => sys.systemId === activeSystemId
    );
    if (!activeSystem || !systemPhasesMap[activeSystemId]) return [];

    return systemPhasesMap[activeSystemId]
      .filter((phase) => activeSystem.phases.includes(phase.id))
      .map((phase) => ({
        value: phase.id,
        label: phase.name,
      }));
  };

  const areAllSystemsSelected = (selectedSystems) => {
    const selectedSystemIds = selectedSystems
      .map((sys) => sys.systemId)
      .filter((id) => id !== null);
    return selectedSystemIds.length >= systems.length;
  };

  if (loader || !dataLoaded || !job) {
    return (
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div
                className="breadcrumb header-title"
                style={{ cursor: "pointer" }}
              >
                <h4
                  onClick={() => navigate("/dashboard/app/job-list")}
                  className="text-primary card-title"
                  style={{ cursor: "pointer" }}
                >
                  <span>Job</span>
                </h4>
                <h4 className="mx-2 card-title">{">"}</h4>
                <h4 className="card-title">Job Information</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <FadeLoaderComponent />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  }

  return (
    <>
      {(hasUpdatePermission ||
        hasViewPermission ||
        decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )) && (
        <div>
          <Formik
            enableReinitialize={true}
            initialValues={{
              ...job,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              handleChange,
              handleBlur,
              touched,
              setFieldValue,
              handleSubmit,
              isSubmitting,
              resetForm,
              errors: errorsFormik,
            }) => (
              <Form onSubmit={handleSubmit}>
                <FocusError />
                <Row>
                  <Col xl="12" lg="12" ref={alertRef}>
                    <Card>
                      <Card.Header className="d-flex justify-content-between">
                        <div
                          className="header-title breadcrumb"
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleCollapse("jobInfo")}
                        >
                          <h4
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/dashboard/app/job-list");
                            }}
                            className="text-primary card-title"
                            style={{ cursor: "pointer" }}
                          >
                            <span>Job</span>
                          </h4>
                          <h4 className="mx-2 card-title">{">"}</h4>
                          <h4 className="card-title">
                            {isCompleted ||
                            (!hasUpdatePermission &&
                              decodedToken?.roles?.some(
                                (role) =>
                                  role.role_type !== roleTypes.SUPER_ADMIN
                              ))
                              ? "View"
                              : (hasUpdatePermission ||
                                  decodedToken?.roles?.some(
                                    (role) =>
                                      role.role_type === roleTypes.SUPER_ADMIN
                                  )) &&
                                "Edit"}
                          </h4>
                          <h4 className="mx-2 card-title">{">"}</h4>
                          <h4 className="card-title">{values.name}</h4>
                        </div>
                        <div>
                          <div
                            onClick={() => toggleCollapse("jobInfo")}
                            className="sidebar-toggle"
                            style={{
                              position: "initial",
                              marginRight: "1.5rem",
                              cursor: "pointer",
                            }}
                          >
                            <i
                              className="icon"
                              style={{
                                transform: collapsedSections.jobInfo
                                  ? "rotate(270deg)"
                                  : "rotate(90deg)",
                              }}
                            >
                              <svg
                                width="20"
                                className="icon-20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.25 12.2744L19.25 12.2744"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </i>
                          </div>
                        </div>
                      </Card.Header>
                      {!collapsedSections.jobInfo && (
                        <Card.Body>
                          <AlertNotificationSimple
                            type={alert.type}
                            message={alert.message}
                            show={alert.show}
                            onClose={() => setAlert({ ...alert, show: false })}
                          />

                          <Row>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="name"
                                placeholder="Enter project name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.name}
                                disabled={
                                  isCompleted ||
                                  (!hasUpdatePermission &&
                                    decodedToken?.roles?.some(
                                      (role) =>
                                        role.role_type !== roleTypes.SUPER_ADMIN
                                    ))
                                }
                                label="Project Name"
                              />
                            </Col>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="location"
                                placeholder="Enter address"
                                value={values.location}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                errorMessage={errors?.location}
                                disabled={
                                  isCompleted ||
                                  (!hasUpdatePermission &&
                                    decodedToken?.roles?.some(
                                      (role) =>
                                        role.role_type !== roleTypes.SUPER_ADMIN
                                    ))
                                }
                                label="Address"
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="estimate"
                                placeholder="Enter estimate"
                                value={values.estimate}
                                disabled={
                                  isCompleted ||
                                  (!hasUpdatePermission &&
                                    decodedToken?.roles?.some(
                                      (role) =>
                                        role.role_type !== roleTypes.SUPER_ADMIN
                                    ))
                                }
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (
                                    /^\d{0,12}(\.\d{0,2})?$/.test(value) ||
                                    value === ""
                                  ) {
                                    setFieldValue("estimate", value);
                                  }
                                }}
                                onBlur={(e) => {
                                  let value = e.target.value.trim();
                                  if (value === "") return;
                                  if (value.startsWith("."))
                                    value = "0" + value;
                                  if (value.endsWith("."))
                                    value = value.slice(0, -1);
                                  if (!isNaN(value)) {
                                    const [intPart, decPart] = value.split(".");
                                    if (intPart.length > 12) {
                                      value =
                                        intPart.slice(0, 12) +
                                        (decPart
                                          ? "." + decPart.slice(0, 2)
                                          : "");
                                    } else if (decPart) {
                                      value = `${intPart}.${decPart.slice(
                                        0,
                                        2
                                      )}`;
                                    }
                                  }

                                  setFieldValue("estimate", value);
                                }}
                                errorMessage={errors?.estimate}
                                label="Estimate"
                                step="0.01"
                                pattern="^\d{1,12}(\.\d{1,2})?$"
                                min={0}
                              />
                            </Col>
                            <Col md={6}>
                              <DatePickerField
                                className="col-md-12 form-group"
                                name="bidDate"
                                placeholder="Enter start date"
                                value={values.bidDate}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.bidDate}
                                disabled={
                                  isCompleted ||
                                  (!hasUpdatePermission &&
                                    decodedToken?.roles?.some(
                                      (role) =>
                                        role.role_type !== roleTypes.SUPER_ADMIN
                                    ))
                                }
                                label="Start Date"
                                minDate={
                                  job?.bidDate ? new Date(job.bidDate) : null
                                }
                                dateFormat="MM/dd/yyyy"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              {isCompleted ||
                              (!hasUpdatePermission &&
                                decodedToken?.roles?.some(
                                  (role) =>
                                    role.role_type !== roleTypes.SUPER_ADMIN
                                )) ? (
                                <InputField
                                  className="col-md-12 form-group"
                                  type="text"
                                  name="jobStatus"
                                  value={values.jobStatus || ""}
                                  asterick={true}
                                  label="Job Status"
                                  disabled={
                                    isCompleted ||
                                    (!hasUpdatePermission &&
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type !==
                                          roleTypes.SUPER_ADMIN
                                      ))
                                  }
                                />
                              ) : (
                                <>
                                  <Form.Label htmlFor="jobStatus">
                                    Job Status
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <div title={values.jobStatus || ""}>
                                    <Select
                                      closeMenuOnScroll={(e) => {
                                        try {
                                          const target = e.target;

                                          if (
                                            !target ||
                                            !target.nodeType ||
                                            typeof target.closest !== "function"
                                          ) {
                                            return true;
                                          }

                                          const isMenuScroll =
                                            target.closest(
                                              '[class*="MenuList"]'
                                            ) ||
                                            target.closest('[class*="menu"]');

                                          return !isMenuScroll;
                                        } catch (error) {
                                          return true;
                                        }
                                      }}
                                      name={`jobStatus`}
                                      options={optionsJobStatus}
                                      value={
                                        (optionsJobStatus.length > 0 &&
                                          optionsJobStatus.find(
                                            (option) =>
                                              option.value === values.jobStatus
                                          )) ||
                                        null
                                      }
                                      onChange={(selectedOption) => {
                                        setFieldValue(
                                          `jobStatus`,
                                          selectedOption?.value || ""
                                        );
                                      }}
                                      isClearable
                                      placeholder="Select job status"
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      menuPlacement="auto"
                                      styles={customSelectStyles}
                                    />
                                  </div>
                                  <ErrorMessage
                                    name={`jobStatus`}
                                    component="div"
                                    className="text-danger"
                                  />
                                  {errors?.jobStatus?.map((error, index) => (
                                    <span
                                      key={index}
                                      className="w-100 mt-1 small text-danger"
                                    >
                                      {error}
                                      <br />
                                    </span>
                                  ))}
                                </>
                              )}
                            </Col>
                            <Col md={6}>
                              <InputField
                                className="col-md-12 form-group"
                                type="text"
                                name="siteName"
                                placeholder="Enter site name"
                                value={values.siteName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.siteName}
                                disabled={
                                  isCompleted ||
                                  (!hasUpdatePermission &&
                                    decodedToken?.roles?.some(
                                      (role) =>
                                        role.role_type !== roleTypes.SUPER_ADMIN
                                    ))
                                }
                                label="Site Name"
                              />
                            </Col>
                          </Row>

                          {isCompleted ||
                          (!hasUpdatePermission &&
                            decodedToken?.roles?.some(
                              (role) => role.role_type !== roleTypes.SUPER_ADMIN
                            )) ? (
                            <>
                              <Row className="mb-3 mt-4">
                                <Col md={12}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="text-primary mb-0">
                                      Systems & Phases
                                    </h5>
                                  </div>
                                </Col>
                              </Row>
                              <Card className="p-2 p-md-4 border rounded">
                                <FieldArray name="systems">
                                  {() => (
                                    <>
                                      {values.systems?.map((system, index) => {
                                        const phases =
                                          system.systemId &&
                                          systemPhasesMap[system.systemId]
                                            ? systemPhasesMap[system.systemId]
                                            : [];
                                        const systemName =
                                          systems.find(
                                            (s) => s.id === system.systemId
                                          )?.name || "";

                                        return (
                                          <div key={index} className="mb-4 p-3">
                                            <Row>
                                              <Col md={6}>
                                                <Form.Group className="form-group">
                                                  <Form.Label>
                                                    System
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="text"
                                                    value={systemName}
                                                    disabled={true}
                                                    readOnly
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={5}>
                                                <Form.Group className="">
                                                  <Form.Label>
                                                    Phases
                                                  </Form.Label>
                                                  <Form.Control
                                                    as="textarea"
                                                    disabled
                                                    rows={3}
                                                    value={
                                                      system.systemId
                                                        ? phases
                                                            .filter((phase) =>
                                                              system.phases.includes(
                                                                phase.id
                                                              )
                                                            )
                                                            .reduce(
                                                              (
                                                                acc,
                                                                phase,
                                                                index,
                                                                array
                                                              ) => {
                                                                const separator =
                                                                  (index + 1) %
                                                                    2 ===
                                                                  0
                                                                    ? "\n"
                                                                    : " | ";
                                                                return (
                                                                  acc +
                                                                  phase.name +
                                                                  (index ===
                                                                  array.length -
                                                                    1
                                                                    ? ""
                                                                    : separator)
                                                                );
                                                              },
                                                              ""
                                                            )
                                                        : ""
                                                    }
                                                    placeholder={
                                                      !system.systemId
                                                        ? "First select a system"
                                                        : phases.length === 0
                                                        ? "No phases available"
                                                        : "All phases selected"
                                                    }
                                                    style={{
                                                      resize: "none",
                                                      height: "5rem",
                                                      overflowX: "hidden",
                                                      backgroundColor: "#fff",
                                                      cursor: "not-allowed",
                                                      whiteSpace: "pre-wrap",
                                                    }}
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          </div>
                                        );
                                      })}
                                    </>
                                  )}
                                </FieldArray>
                              </Card>
                              <Row className="mb-3 mt-4">
                                <Col md={6}>
                                  <InputField
                                    className="col-md-12 form-group"
                                    type="text"
                                    name="activeSystem"
                                    value={jobData?.active_system_name || ""}
                                    asterick={true}
                                    label="Current Active System"
                                    disabled
                                  />
                                </Col>
                                <Col md={6}>
                                  <InputField
                                    className="col-md-12 form-group"
                                    type="text"
                                    name="activePhase"
                                    value={jobData?.active_phase_name || ""}
                                    asterick={true}
                                    label="Current Active Phase"
                                    disabled
                                  />
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <>
                              <Row className="mb-3 mt-4">
                                <Col md={12}>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="text-primary mb-0">
                                      Systems & Phases
                                    </h5>
                                  </div>
                                </Col>
                              </Row>
                              <Card className="p-2 p-md-4 border rounded">
                                <FieldArray name="systems">
                                  {({ push, remove }) => (
                                    <>
                                      {values.systems?.map((system, index) => {
                                        const phases =
                                          system.systemId &&
                                          systemPhasesMap[system.systemId]
                                            ? systemPhasesMap[system.systemId]
                                            : [];
                                        const availableOptions =
                                          getAvailableSystemOptions(
                                            values.systems,
                                            index
                                          );
                                        const isDisabled =
                                          jobData?.systems?.some(
                                            (js) =>
                                              js.system_id === system.systemId
                                          ) || false;

                                        return (
                                          <div key={index} className="mb-4 p-3">
                                            <Row>
                                              <Col md={6}>
                                                <Form.Group className="form-group">
                                                  <Form.Label>
                                                    System
                                                    <span className="text-danger">
                                                      *
                                                    </span>
                                                  </Form.Label>
                                                  <Select
                                                    closeMenuOnScroll={(e) => {
                                                      try {
                                                        const target = e.target;

                                                        if (
                                                          !target ||
                                                          !target.nodeType ||
                                                          typeof target.closest !==
                                                            "function"
                                                        ) {
                                                          return true;
                                                        }

                                                        const isMenuScroll =
                                                          target.closest(
                                                            '[class*="MenuList"]'
                                                          ) ||
                                                          target.closest(
                                                            '[class*="menu"]'
                                                          );

                                                        return !isMenuScroll;
                                                      } catch (error) {
                                                        return true;
                                                      }
                                                    }}
                                                    options={availableOptions}
                                                    name={`systems.${index}.systemId`}
                                                    value={
                                                      system.systemId
                                                        ? availableOptions.find(
                                                            (option) =>
                                                              option.value ===
                                                              system.systemId
                                                          ) ||
                                                          systems
                                                            .filter(
                                                              (s) =>
                                                                s.id ===
                                                                system.systemId
                                                            )
                                                            .map((s) => ({
                                                              value: s.id,
                                                              label: s.name,
                                                            }))[0]
                                                        : null
                                                    }
                                                    onChange={async (
                                                      option
                                                    ) => {
                                                      const newSystemId =
                                                        option?.value || null;
                                                      const oldSystemId =
                                                        system.systemId;
                                                      setFieldValue(
                                                        `systems.${index}.systemId`,
                                                        newSystemId
                                                      );

                                                      if (newSystemId) {
                                                        const fetchedPhases =
                                                          await getPhases(
                                                            newSystemId,
                                                            index
                                                          );
                                                        setSystemPhasesMap(
                                                          (prev) => ({
                                                            ...prev,
                                                            [newSystemId]:
                                                              fetchedPhases,
                                                          })
                                                        );

                                                        const allPhaseIds =
                                                          fetchedPhases.map(
                                                            (phase) => phase.id
                                                          );
                                                        setFieldValue(
                                                          `systems.${index}.phases`,
                                                          allPhaseIds
                                                        );

                                                        const updatedSystems =
                                                          values.systems.map(
                                                            (sys, idx) =>
                                                              idx === index
                                                                ? {
                                                                    ...sys,
                                                                    systemId:
                                                                      newSystemId,
                                                                    phases:
                                                                      allPhaseIds,
                                                                  }
                                                                : sys
                                                          );

                                                        const currentActiveSystemIndex =
                                                          updatedSystems.findIndex(
                                                            (sys) =>
                                                              sys.systemId ===
                                                              values.activeSystemId
                                                          );

                                                        if (index === 0) {
                                                          if (
                                                            !values.activeSystemId ||
                                                            currentActiveSystemIndex ===
                                                              0
                                                          ) {
                                                            const defaultPhaseId =
                                                              fetchedPhases?.[0]
                                                                ?.id || null;
                                                            setFieldValue(
                                                              "activeSystemId",
                                                              newSystemId
                                                            );
                                                            setFieldValue(
                                                              "activePhaseId",
                                                              defaultPhaseId
                                                            );
                                                          }
                                                        } else {
                                                          const currentSystemExists =
                                                            updatedSystems.some(
                                                              (sys) =>
                                                                sys.systemId ===
                                                                values.activeSystemId
                                                            );

                                                          if (
                                                            !currentSystemExists
                                                          ) {
                                                            const firstSystem =
                                                              updatedSystems.find(
                                                                (sys) =>
                                                                  sys.systemId !==
                                                                  null
                                                              );
                                                            if (firstSystem) {
                                                              const firstSystemPhases =
                                                                systemPhasesMap[
                                                                  firstSystem
                                                                    .systemId
                                                                ] ||
                                                                (firstSystem.systemId ===
                                                                newSystemId
                                                                  ? fetchedPhases
                                                                  : []);
                                                              setFieldValue(
                                                                "activeSystemId",
                                                                firstSystem.systemId
                                                              );
                                                              setFieldValue(
                                                                "activePhaseId",
                                                                firstSystemPhases?.[0]
                                                                  ?.id || null
                                                              );
                                                            } else {
                                                              setFieldValue(
                                                                "activeSystemId",
                                                                null
                                                              );
                                                              setFieldValue(
                                                                "activePhaseId",
                                                                null
                                                              );
                                                            }
                                                          } else {
                                                            const currentSystem =
                                                              updatedSystems.find(
                                                                (sys) =>
                                                                  sys.systemId ===
                                                                  values.activeSystemId
                                                              );
                                                            if (
                                                              currentSystem &&
                                                              values.activePhaseId
                                                            ) {
                                                              const currentSystemPhases =
                                                                systemPhasesMap[
                                                                  values
                                                                    .activeSystemId
                                                                ] || [];
                                                              const phaseExists =
                                                                currentSystemPhases.some(
                                                                  (phase) =>
                                                                    phase.id ===
                                                                    values.activePhaseId
                                                                );
                                                              if (
                                                                !phaseExists
                                                              ) {
                                                                setFieldValue(
                                                                  "activePhaseId",
                                                                  currentSystemPhases?.[0]
                                                                    ?.id || null
                                                                );
                                                              }
                                                            }
                                                          }
                                                        }
                                                      } else {
                                                        setFieldValue(
                                                          `systems.${index}.phases`,
                                                          []
                                                        );

                                                        if (
                                                          oldSystemId ===
                                                          values.activeSystemId
                                                        ) {
                                                          const updatedSystems =
                                                            values.systems.map(
                                                              (sys, idx) =>
                                                                idx === index
                                                                  ? {
                                                                      ...sys,
                                                                      systemId:
                                                                        null,
                                                                      phases:
                                                                        [],
                                                                    }
                                                                  : sys
                                                            );
                                                          const firstSystem =
                                                            updatedSystems.find(
                                                              (sys) =>
                                                                sys.systemId !==
                                                                null
                                                            );
                                                          if (firstSystem) {
                                                            const firstSystemPhases =
                                                              systemPhasesMap[
                                                                firstSystem
                                                                  .systemId
                                                              ] || [];
                                                            setFieldValue(
                                                              "activeSystemId",
                                                              firstSystem.systemId
                                                            );
                                                            setFieldValue(
                                                              "activePhaseId",
                                                              firstSystemPhases?.[0]
                                                                ?.id || null
                                                            );
                                                          } else {
                                                            setFieldValue(
                                                              "activeSystemId",
                                                              null
                                                            );
                                                            setFieldValue(
                                                              "activePhaseId",
                                                              null
                                                            );
                                                          }
                                                        }
                                                      }
                                                    }}
                                                    onMenuOpen={() =>
                                                      setOpenSystemMenuIndex(
                                                        index
                                                      )
                                                    }
                                                    setOpenTypeMenuIndex={
                                                      setOpenTypeMenuIndex
                                                    }
                                                    setOpenContactMenuIndex={
                                                      setOpenContactMenuIndex
                                                    }
                                                    onMenuClose={() => {
                                                      if (!isAddingNewSystem) {
                                                        setOpenSystemMenuIndex(
                                                          null
                                                        );
                                                      }
                                                    }}
                                                    menuIsOpen={
                                                      openSystemMenuIndex ===
                                                      index
                                                    }
                                                    closeMenuOnSelect={
                                                      !isAddingNewSystem
                                                    }
                                                    components={{
                                                      MenuList:
                                                        CustomSystemMenuList,
                                                    }}
                                                    hasCreateSystemPermission={
                                                      hasCreateSystemPermission
                                                    }
                                                    hasCreatePhasePermission={
                                                      hasCreatePhasePermission
                                                    }
                                                    isSuperAdmin={isSuperAdmin}
                                                    isAddingNewSystem={
                                                      isAddingNewSystem
                                                    }
                                                    setIsAddingNewSystem={
                                                      setIsAddingNewSystem
                                                    }
                                                    setIsAddingNewContact={
                                                      setIsAddingNewContact
                                                    }
                                                    setIsAddingNewType={
                                                      setIsAddingNewType
                                                    }
                                                    newSystemData={
                                                      newSystemData
                                                    }
                                                    setNewSystemData={
                                                      setNewSystemData
                                                    }
                                                    newSystemError={
                                                      newSystemError
                                                    }
                                                    setNewSystemError={
                                                      setNewSystemError
                                                    }
                                                    isSubmittingNewSystem={
                                                      isSubmittingNewSystem
                                                    }
                                                    handleSubmitNewSystem={() =>
                                                      handleSubmitNewSystem(
                                                        setFieldValue,
                                                        index
                                                      )
                                                    }
                                                    handleCancelNewSystem={
                                                      handleCancelNewSystem
                                                    }
                                                    isDisabled={isDisabled}
                                                    placeholder="Select a system..."
                                                    isSearchable
                                                    isClearable
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    menuPlacement="auto"
                                                    styles={{
                                                      ...customSelectStyles,
                                                      menuPortal: (
                                                        provided
                                                      ) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                      }),
                                                      menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                      }),
                                                      control: (
                                                        provided,
                                                        state
                                                      ) => ({
                                                        ...customSelectStyles.control(
                                                          provided,
                                                          state
                                                        ),
                                                        cursor:
                                                          jobData?.systems?.some(
                                                            (js) =>
                                                              js.system_id ===
                                                              system.systemId
                                                          )
                                                            ? "not-allowed"
                                                            : "default",
                                                      }),
                                                    }}
                                                  />
                                                  <ErrorMessage
                                                    name={`systems.${index}.systemId`}
                                                    component="div"
                                                    className="text-danger small mt-1"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col md={5}>
                                                <Form.Group className="">
                                                  <Form.Label>
                                                    Phases
                                                  </Form.Label>
                                                  <Form.Control
                                                    as="textarea"
                                                    disabled
                                                    rows={3}
                                                    value={
                                                      system.systemId
                                                        ? phases
                                                            .filter((phase) =>
                                                              system.phases.includes(
                                                                phase.id
                                                              )
                                                            )
                                                            .reduce(
                                                              (
                                                                acc,
                                                                phase,
                                                                index,
                                                                array
                                                              ) => {
                                                                const separator =
                                                                  (index + 1) %
                                                                    2 ===
                                                                  0
                                                                    ? "\n"
                                                                    : " | ";
                                                                return (
                                                                  acc +
                                                                  phase.name +
                                                                  (index ===
                                                                  array.length -
                                                                    1
                                                                    ? ""
                                                                    : separator)
                                                                );
                                                              },
                                                              ""
                                                            )
                                                        : ""
                                                    }
                                                    placeholder={
                                                      isSubmitSystem[index]
                                                        ? "Loading phases..."
                                                        : !system.systemId
                                                        ? "First select a system"
                                                        : phases.length === 0
                                                        ? "No phases available"
                                                        : "All phases selected"
                                                    }
                                                    style={{
                                                      resize: "none",
                                                      height: "5rem",
                                                      overflowx: "hidden",
                                                      backgroundColor: "#fff",
                                                      cursor: "not-allowed",
                                                      whiteSpace: "pre-wrap",
                                                    }}
                                                  />
                                                  <ErrorMessage
                                                    name={`systems.${index}.phases`}
                                                    component="div"
                                                    className="text-danger small mt-1"
                                                  />
                                                </Form.Group>
                                              </Col>

                                              <Col
                                                md={1}
                                                className="d-flex align-items-center pt-3"
                                              >
                                                {values.systems.length > 1 &&
                                                  !jobData?.systems?.some(
                                                    (js) =>
                                                      js.system_id ===
                                                      system.systemId
                                                  ) && (
                                                    <Button
                                                      variant="outline-danger"
                                                      size="sm"
                                                      className="d-flex align-items-end"
                                                      onClick={() => {
                                                        const willRemoveActiveSystem =
                                                          values.activeSystemId ===
                                                          system.systemId;
                                                        remove(index);

                                                        setTimeout(() => {
                                                          const updatedSystems =
                                                            values.systems.filter(
                                                              (_, idx) =>
                                                                idx !== index
                                                            );
                                                          const currentSystemExists =
                                                            updatedSystems.some(
                                                              (sys) =>
                                                                sys.systemId ===
                                                                values.activeSystemId
                                                            );

                                                          if (
                                                            !currentSystemExists ||
                                                            willRemoveActiveSystem
                                                          ) {
                                                            const firstSystem =
                                                              updatedSystems.find(
                                                                (sys) =>
                                                                  sys.systemId !==
                                                                  null
                                                              );
                                                            if (firstSystem) {
                                                              const firstSystemPhases =
                                                                systemPhasesMap[
                                                                  firstSystem
                                                                    .systemId
                                                                ] || [];
                                                              setFieldValue(
                                                                "activeSystemId",
                                                                firstSystem.systemId
                                                              );
                                                              setFieldValue(
                                                                "activePhaseId",
                                                                firstSystemPhases?.[0]
                                                                  ?.id || null
                                                              );
                                                            } else {
                                                              setFieldValue(
                                                                "activeSystemId",
                                                                null
                                                              );
                                                              setFieldValue(
                                                                "activePhaseId",
                                                                null
                                                              );
                                                            }
                                                          }
                                                        }, 0);
                                                      }}
                                                      title="Remove system"
                                                    >
                                                      <RxCross2 size={18} />
                                                    </Button>
                                                  )}
                                              </Col>
                                            </Row>
                                          </div>
                                        );
                                      })}

                                      <Row className="px-3 px-md-4">
                                        <Col md={12}>
                                          <Button
                                            type="button"
                                            variant="btn btn-primary"
                                            size="md"
                                            disabled={
                                              areAllSystemsSelected(
                                                values.systems
                                              ) &&
                                              values.systems.some(
                                                (sys) => sys.systemId === null
                                              )
                                            }
                                            onClick={() => {
                                              push({
                                                systemId: null,
                                                phases: [],
                                              });
                                            }}
                                            className="d-flex align-items-center"
                                          >
                                            <FaPlus
                                              className="me-2"
                                              size={14}
                                            />
                                            Add More System
                                          </Button>
                                        </Col>
                                      </Row>
                                      <Row className="mb-3 mt-4 px-3 px-md-4">
                                        <Col md={6}>
                                          <Form.Group className="form-group">
                                            <Form.Label>
                                              Current Active System
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Select
                                              closeMenuOnScroll={(e) => {
                                                try {
                                                  const target = e.target;

                                                  if (
                                                    !target ||
                                                    !target.nodeType ||
                                                    typeof target.closest !==
                                                      "function"
                                                  ) {
                                                    return true;
                                                  }

                                                  const isMenuScroll =
                                                    target.closest(
                                                      '[class*="MenuList"]'
                                                    ) ||
                                                    target.closest(
                                                      '[class*="menu"]'
                                                    );

                                                  return !isMenuScroll;
                                                } catch (error) {
                                                  return true;
                                                }
                                              }}
                                              options={getActiveSystemOptions(
                                                values.systems
                                              )}
                                              value={
                                                values.activeSystemId
                                                  ? getActiveSystemOptions(
                                                      values.systems
                                                    ).find(
                                                      (opt) =>
                                                        opt.value ===
                                                        values.activeSystemId
                                                    )
                                                  : null
                                              }
                                              onChange={(option) => {
                                                const selectedSystemId =
                                                  option?.value || null;
                                                setFieldValue(
                                                  "activeSystemId",
                                                  selectedSystemId
                                                );

                                                const systemExists =
                                                  values.systems.some(
                                                    (sys) =>
                                                      sys.systemId ===
                                                      selectedSystemId
                                                  );

                                                if (
                                                  selectedSystemId &&
                                                  systemExists
                                                ) {
                                                  const selectedSystemPhases =
                                                    systemPhasesMap[
                                                      selectedSystemId
                                                    ] || [];
                                                  setFieldValue(
                                                    "activePhaseId",
                                                    selectedSystemPhases?.[0]
                                                      ?.id || null
                                                  );
                                                } else {
                                                  setFieldValue(
                                                    "activePhaseId",
                                                    null
                                                  );
                                                }
                                              }}
                                              placeholder="Select active system..."
                                              isSearchable
                                              isClearable
                                              isDisabled={
                                                values.systems.length === 0 ||
                                                !values.systems.some(
                                                  (sys) => sys.systemId !== null
                                                )
                                              }
                                              menuPortalTarget={document.body}
                                              menuPosition="fixed"
                                              menuPlacement="auto"
                                              styles={{
                                                ...customSelectStyles,
                                                control: (provided, state) => ({
                                                  ...customSelectStyles.control(
                                                    provided,
                                                    state
                                                  ),
                                                  backgroundColor:
                                                    values.systems.length ===
                                                      0 ||
                                                    !values.systems.some(
                                                      (sys) =>
                                                        sys.systemId !== null
                                                    )
                                                      ? "#f8f9fa"
                                                      : "#fff",
                                                }),
                                              }}
                                            />
                                            <ErrorMessage
                                              name="activeSystemId"
                                              component="div"
                                              className="text-danger small mt-1"
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                          <Form.Group className="form-group">
                                            <Form.Label>
                                              Current Active Phase
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Select
                                              closeMenuOnScroll={(e) => {
                                                try {
                                                  const target = e.target;

                                                  if (
                                                    !target ||
                                                    !target.nodeType ||
                                                    typeof target.closest !==
                                                      "function"
                                                  ) {
                                                    return true;
                                                  }

                                                  const isMenuScroll =
                                                    target.closest(
                                                      '[class*="MenuList"]'
                                                    ) ||
                                                    target.closest(
                                                      '[class*="menu"]'
                                                    );

                                                  return !isMenuScroll;
                                                } catch (error) {
                                                  return true;
                                                }
                                              }}
                                              options={getActivePhaseOptions(
                                                values.systems,
                                                values.activeSystemId
                                              )}
                                              value={
                                                values.activePhaseId
                                                  ? getActivePhaseOptions(
                                                      values.systems,
                                                      values.activeSystemId
                                                    ).find(
                                                      (opt) =>
                                                        opt.value ===
                                                        values.activePhaseId
                                                    )
                                                  : null
                                              }
                                              onChange={(option) => {
                                                setFieldValue(
                                                  "activePhaseId",
                                                  option?.value || null
                                                );
                                              }}
                                              placeholder={
                                                !values.activeSystemId
                                                  ? "First select active system"
                                                  : "Select active phase..."
                                              }
                                              isSearchable
                                              isClearable
                                              isDisabled={
                                                !values.activeSystemId
                                              }
                                              menuPortalTarget={document.body}
                                              menuPosition="fixed"
                                              menuPlacement="auto"
                                              styles={{
                                                ...customSelectStyles,
                                                control: (provided, state) => ({
                                                  ...customSelectStyles.control(
                                                    provided,
                                                    state
                                                  ),
                                                  backgroundColor:
                                                    !values.activeSystemId
                                                      ? "#f8f9fa"
                                                      : "#fff",
                                                }),
                                              }}
                                            />
                                            <ErrorMessage
                                              name="activePhaseId"
                                              component="div"
                                              className="text-danger small mt-1"
                                            />
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </FieldArray>
                              </Card>
                            </>
                          )}

                          <Row>
                            {isCompleted ||
                            (!hasUpdatePermission &&
                              decodedToken?.roles?.some(
                                (role) =>
                                  role.role_type !== roleTypes.SUPER_ADMIN
                              )) ? (
                              jobData?.area?.map((area, index) => (
                                <Col md={6} key={index}>
                                  <InputField
                                    className="col-md-12 form-group"
                                    type="text"
                                    name={`area.${index}`}
                                    value={area || ""}
                                    asterick={true}
                                    label="Area"
                                    disabled
                                  />
                                </Col>
                              ))
                            ) : (
                              <>
                                <Form.Label htmlFor="area">Area</Form.Label>
                                <FieldArray
                                  name="area"
                                  render={(arrayHelpers) => (
                                    <>
                                      {values?.area?.map((are, index) => (
                                        <React.Fragment key={index}>
                                          <Col
                                            md={6}
                                            className="d-flex flex-row align-items-start "
                                          >
                                            <Col md={10} className="mb-3">
                                              <Form.Control
                                                id={`area.${index}`}
                                                name={`area.${index}`}
                                                value={are}
                                                onChange={(e) =>
                                                  setFieldValue(
                                                    `area.${index}`,
                                                    e.target.value
                                                  )
                                                }
                                                onBlur={handleBlur}
                                                placeholder="e.g first floor"
                                              />
                                              <ErrorMessage
                                                name={`area.${index}`}
                                                component="div"
                                                className="text-danger"
                                              />
                                            </Col>

                                            {values.area.length > 1 && (
                                              <Button
                                                variant="danger"
                                                className="d-flex align-items-center justify-content-center ms-2"
                                                onClick={() =>
                                                  arrayHelpers.remove(index)
                                                }
                                              >
                                                <RxCross2
                                                  style={{
                                                    width: "22px",
                                                    height: "22px",
                                                  }}
                                                  color="white"
                                                />
                                              </Button>
                                            )}
                                          </Col>
                                        </React.Fragment>
                                      ))}

                                      <Row className="mb-3">
                                        <Col md={12}>
                                          <Button
                                            type="button"
                                            variant="btn btn-primary"
                                            size="md"
                                            disabled={values.area.length >= 5}
                                            onClick={() => {
                                              arrayHelpers.push("");
                                            }}
                                            className="d-flex align-items-center"
                                          >
                                            <FaPlus
                                              className="me-2"
                                              size={14}
                                            />
                                            Add More Area
                                          </Button>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                />
                              </>
                            )}
                          </Row>

                          <FieldArray name="contacts">
                            {({ push, remove }) => {
                              const getAvailableStakeholderTypes = () => {
                                const selectedTypes = values.contacts
                                  ?.map((contact) => {
                                    const selectedStakeholder =
                                      optionsStakeholder.find(
                                        (option) =>
                                          option.value === contact.stakeholderId
                                      );
                                    return selectedStakeholder
                                      ? selectedStakeholder.type
                                      : null;
                                  })
                                  .filter((type) => type !== null);

                                const availableTypes = [
                                  ...new Set(
                                    optionsStakeholder.map(
                                      (option) => option.type
                                    )
                                  ),
                                ].filter(
                                  (type) => !selectedTypes?.includes(type)
                                );
                                return availableTypes;
                              };

                              const hasAvailableStakeholders = () => {
                                return (
                                  getAvailableStakeholderTypes().length > 0
                                );
                              };

                              return (
                                <>
                                  <Row className="mb-3 mt-2">
                                    <Col md={12}>
                                      <div className="d-flex justify-content-between align-items-center ">
                                        <h5 className="text-primary mb-0">
                                          Stakeholders
                                        </h5>
                                      </div>
                                    </Col>
                                  </Row>
                                  {!isCompleted &&
                                    touched.contacts &&
                                    errorsFormik.contacts &&
                                    typeof errorsFormik.contacts ===
                                      "string" && (
                                      <Row className="mb-3">
                                        <Col md={12}>
                                          <div className="text-danger small">
                                            {errorsFormik.contacts}
                                          </div>
                                        </Col>
                                      </Row>
                                    )}
                                  {errors?.contacts && (
                                    <Row className="mb-3">
                                      <Col md={12}>
                                        <div className="text-danger small">
                                          {Array.isArray(errors.contacts)
                                            ? errors.contacts.join(", ")
                                            : errors.contacts}
                                        </div>
                                      </Col>
                                    </Row>
                                  )}

                                  {(isCompleted ||
                                    (!hasUpdatePermission &&
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type !==
                                          roleTypes.SUPER_ADMIN
                                      ))) &&
                                    values.contacts?.map((contact, index) => {
                                      const stakeholderOption =
                                        optionsStakeholder.find(
                                          (s) =>
                                            s.value === contact.stakeholderId
                                        );
                                      const stakeholder = stakeholderOption
                                        ? { name: stakeholderOption.label }
                                        : null;
                                      const contactData = allContacts[
                                        contact.stakeholderId
                                      ]?.find(
                                        (c) => c.id === contact.contactId
                                      );

                                      return (
                                        <Row key={index} className="mb-3">
                                          <Col md={4}>
                                            <InputField
                                              className="col-md-12 form-group"
                                              type="text"
                                              name={`contacts.${index}.stakeholder`}
                                              value={stakeholder?.name || ""}
                                              disabled={true}
                                              label="Stakeholder"
                                            />
                                          </Col>
                                          <Col md={4}>
                                            <InputField
                                              className="col-md-12 form-group"
                                              type="text"
                                              name={`contacts.${index}.type`}
                                              value={contact.type || ""}
                                              disabled={true}
                                              label="Type"
                                            />
                                          </Col>
                                          <Col md={4}>
                                            <InputField
                                              className="col-md-12 form-group"
                                              type="text"
                                              name={`contacts.${index}.contact`}
                                              value={
                                                contactData
                                                  ? `${contactData.name}${
                                                      contactData.phone
                                                        ? ` - ${contactData.phone}`
                                                        : ""
                                                    }${
                                                      contactData.email
                                                        ? ` - ${contactData.email}`
                                                        : ""
                                                    }`
                                                  : ""
                                              }
                                              disabled={true}
                                              label="Contact"
                                            />
                                          </Col>
                                        </Row>
                                      );
                                    })}

                                  {!isCompleted &&
                                    (hasUpdatePermission ||
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type ===
                                          roleTypes.SUPER_ADMIN
                                      )) &&
                                    values.contacts?.map((contact, index) => {
                                      const currentStakeholderOptions =
                                        optionsStakeholder;

                                      const isStakeholderSelected =
                                        contact.stakeholderId !== null;
                                      const isLoadingContacts =
                                        contactsLoadingMap[index] === true;
                                      const contactOptions =
                                        getContactOptionsForStakeholder(
                                          contact.stakeholderId
                                        );

                                      return (
                                        <div key={index} className="mb-3">
                                          <Row>
                                            <Col md={4}>
                                              <Form.Label>
                                                Stakeholder
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </Form.Label>
                                              <Select
                                                closeMenuOnScroll={(e) => {
                                                  try {
                                                    const target = e.target;

                                                    if (
                                                      !target ||
                                                      !target.nodeType ||
                                                      typeof target.closest !==
                                                        "function"
                                                    ) {
                                                      return true;
                                                    }

                                                    const isMenuScroll =
                                                      target.closest(
                                                        '[class*="MenuList"]'
                                                      ) ||
                                                      target.closest(
                                                        '[class*="menu"]'
                                                      );

                                                    return !isMenuScroll;
                                                  } catch (error) {
                                                    return true;
                                                  }
                                                }}
                                                name={`contacts.${index}.stakeholderId`}
                                                options={
                                                  currentStakeholderOptions
                                                }
                                                value={
                                                  contact.stakeholderId
                                                    ? currentStakeholderOptions.find(
                                                        (option) =>
                                                          option.value ===
                                                          contact.stakeholderId
                                                      )
                                                    : null
                                                }
                                                onChange={async (
                                                  selectedOption
                                                ) => {
                                                  setFieldValue(
                                                    `contacts.${index}.stakeholderId`,
                                                    selectedOption?.value ||
                                                      null
                                                  );
                                                  setFieldValue(
                                                    `contacts.${index}.type`,
                                                    ""
                                                  );
                                                  setFieldValue(
                                                    `contacts.${index}.contactId`,
                                                    null
                                                  );

                                                  if (selectedOption) {
                                                    await getContacts(
                                                      selectedOption.value
                                                    );
                                                  } else {
                                                    setFieldValue(
                                                      `contacts.${index}.contactId`,
                                                      null
                                                    );
                                                  }
                                                }}
                                                placeholder="Select Stakeholder"
                                                isClearable
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                maxMenuHeight={380}
                                                disabled={
                                                  isCompleted ||
                                                  (!hasUpdatePermission &&
                                                    decodedToken?.roles?.some(
                                                      (role) =>
                                                        role.role_type !==
                                                        roleTypes.SUPER_ADMIN
                                                    ))
                                                }
                                                styles={customSelectStyles}
                                                formatOptionLabel={(option) => (
                                                  <div className="d-flex align-items-center">
                                                    <span>{option.label}</span>
                                                  </div>
                                                )}
                                              />
                                              <ErrorMessage
                                                name={`contacts.${index}.stakeholderId`}
                                                component="div"
                                                className="text-danger small mt-1"
                                              />
                                              {errors?.contacts?.[index]
                                                ?.stakeholderId && (
                                                <span className="w-100 mt-1 small text-danger">
                                                  {
                                                    errors.contacts[index]
                                                      .stakeholderId
                                                  }
                                                </span>
                                              )}
                                            </Col>

                                            <Col md={3}>
                                              <Form.Group>
                                                <Form.Label>
                                                  Type
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                </Form.Label>
                                                <Select
                                                  closeMenuOnScroll={(e) => {
                                                    try {
                                                      const target = e.target;

                                                      if (
                                                        !target ||
                                                        !target.nodeType ||
                                                        typeof target.closest !==
                                                          "function"
                                                      ) {
                                                        return true;
                                                      }

                                                      const isMenuScroll =
                                                        target.closest(
                                                          '[class*="MenuList"]'
                                                        ) ||
                                                        target.closest(
                                                          '[class*="menu"]'
                                                        );

                                                      return !isMenuScroll;
                                                    } catch (error) {
                                                      return true;
                                                    }
                                                  }}
                                                  name={`contacts.${index}.type`}
                                                  options={getAvailableTypeOptions(
                                                    contact.stakeholderId,
                                                    index,
                                                    values
                                                  )}
                                                  value={
                                                    contact.type &&
                                                    getAvailableTypeOptions(
                                                      contact.stakeholderId,
                                                      index,
                                                      values
                                                    ).find(
                                                      (option) =>
                                                        option.value ===
                                                        contact.type
                                                    )
                                                      ? getAvailableTypeOptions(
                                                          contact.stakeholderId,
                                                          index,
                                                          values
                                                        ).find(
                                                          (option) =>
                                                            option.value ===
                                                            contact.type
                                                        )
                                                      : null
                                                  }
                                                  onChange={(
                                                    selectedOption
                                                  ) => {
                                                    setFieldValue(
                                                      `contacts.${index}.type`,
                                                      selectedOption?.value ||
                                                        ""
                                                    );
                                                    const options =
                                                      getContactOptionsForStakeholder(
                                                        values.contacts[index]
                                                          .stakeholderId
                                                      );
                                                    if (
                                                      selectedOption &&
                                                      options.length > 0 &&
                                                      !values.contacts[index]
                                                        .contactId
                                                    ) {
                                                      setFieldValue(
                                                        `contacts.${index}.contactId`,
                                                        options[0].value
                                                      );
                                                    }
                                                  }}
                                                  onBlur={() =>
                                                    handleBlur({
                                                      target: {
                                                        name: `contacts.${index}.type`,
                                                      },
                                                    })
                                                  }
                                                  placeholder={
                                                    isLoadingContacts
                                                      ? "Loading type..."
                                                      : !isStakeholderSelected
                                                      ? "First select stakeholder"
                                                      : "Select type"
                                                  }
                                                  isDisabled={
                                                    !isStakeholderSelected ||
                                                    isLoadingContacts
                                                  }
                                                  isClearable
                                                  isSearchable
                                                  components={{
                                                    MenuList: CustomMenuList,
                                                  }}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  menuPosition="fixed"
                                                  menuPlacement="auto"
                                                  isAddingNewType={
                                                    isAddingNewType
                                                  }
                                                  setIsAddingNewType={
                                                    setIsAddingNewType
                                                  }
                                                  setIsAddingNewContact={
                                                    setIsAddingNewContact
                                                  }
                                                  newTypeName={newTypeName}
                                                  setNewTypeName={
                                                    setNewTypeName
                                                  }
                                                  newTypeError={newTypeError}
                                                  setNewTypeError={
                                                    setNewTypeError
                                                  }
                                                  newTypeInputRef={
                                                    newTypeInputRef
                                                  }
                                                  isSubmittingNewType={
                                                    isSubmittingNewType
                                                  }
                                                  setOpenContactMenuIndex={
                                                    setOpenContactMenuIndex
                                                  }
                                                  setOpenSystemMenuIndex={
                                                    setOpenSystemMenuIndex
                                                  }
                                                  handleSubmitNewType={() =>
                                                    handleSubmitNewType(
                                                      setFieldValue,
                                                      `contacts.${index}.type`
                                                    )
                                                  }
                                                  handleCancelNewType={
                                                    handleCancelNewType
                                                  }
                                                  setOpenTypeMenuIndex={
                                                    setOpenTypeMenuIndex
                                                  }
                                                  onMenuOpen={() =>
                                                    setOpenTypeMenuIndex(index)
                                                  }
                                                  onMenuClose={() => {
                                                    if (!isAddingNewType) {
                                                      setOpenTypeMenuIndex(
                                                        null
                                                      );
                                                    }
                                                  }}
                                                  menuIsOpen={
                                                    openTypeMenuIndex === index
                                                  }
                                                  closeMenuOnSelect={
                                                    !isAddingNewType
                                                  }
                                                  styles={{
                                                    menuPortal: (provided) => ({
                                                      ...provided,
                                                      zIndex: 9999,
                                                    }),
                                                    menu: (provided) => ({
                                                      ...provided,
                                                      zIndex: 9999,
                                                    }),
                                                    control: (
                                                      provided,
                                                      state
                                                    ) => ({
                                                      ...provided,
                                                      color: "#5e667b",
                                                      borderColor:
                                                        errors?.contacts?.[
                                                          index
                                                        ]?.type ||
                                                        (touched.contacts?.[
                                                          index
                                                        ]?.type &&
                                                          errorsFormik
                                                            .contacts?.[index]
                                                            ?.type)
                                                          ? "#dc3545"
                                                          : provided.borderColor,
                                                      boxShadow: state.isFocused
                                                        ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                                        : provided.boxShadow,
                                                      "&:hover": {
                                                        borderColor:
                                                          errors?.contacts?.[
                                                            index
                                                          ]?.type ||
                                                          (touched.contacts?.[
                                                            index
                                                          ]?.type &&
                                                            errorsFormik
                                                              .contacts?.[index]
                                                              ?.type)
                                                            ? "#dc3545"
                                                            : "#007bff",
                                                      },
                                                    }),
                                                  }}
                                                />
                                                <ErrorMessage
                                                  name={`contacts.${index}.type`}
                                                  component="div"
                                                  className="text-danger small mt-1"
                                                />
                                                {errors?.contacts?.[index]
                                                  ?.type && (
                                                  <span className="w-100 mt-1 small text-danger">
                                                    {
                                                      errors.contacts[index]
                                                        .type
                                                    }
                                                  </span>
                                                )}
                                              </Form.Group>
                                            </Col>

                                            <Col md={4}>
                                              <Form.Label>
                                                Stakeholder Contact{" "}
                                              </Form.Label>
                                              <Select
                                                closeMenuOnScroll={(e) => {
                                                  try {
                                                    const target = e.target;

                                                    if (
                                                      !target ||
                                                      !target.nodeType ||
                                                      typeof target.closest !==
                                                        "function"
                                                    ) {
                                                      return true;
                                                    }

                                                    const isMenuScroll =
                                                      target.closest(
                                                        '[class*="MenuList"]'
                                                      ) ||
                                                      target.closest(
                                                        '[class*="menu"]'
                                                      );

                                                    return !isMenuScroll;
                                                  } catch (error) {
                                                    return true;
                                                  }
                                                }}
                                                name={`contacts.${index}.contactId`}
                                                options={getContactOptionsForStakeholder(
                                                  contact.stakeholderId
                                                )}
                                                value={
                                                  contact.contactId &&
                                                  getContactOptionsForStakeholder(
                                                    contact.stakeholderId
                                                  ).length > 0
                                                    ? getContactOptionsForStakeholder(
                                                        contact.stakeholderId
                                                      ).find(
                                                        (option) =>
                                                          option.value ===
                                                          contact.contactId
                                                      )
                                                    : null
                                                }
                                                onChange={(selectedOption) => {
                                                  setFieldValue(
                                                    `contacts.${index}.contactId`,
                                                    selectedOption?.value ||
                                                      null
                                                  );
                                                }}
                                                placeholder={
                                                  isLoadingContacts
                                                    ? "Loading contacts..."
                                                    : !isStakeholderSelected
                                                    ? "First select stakeholder"
                                                    : !contact.type
                                                    ? "First select type"
                                                    : contactsLoading
                                                    ? "Loading contacts..."
                                                    : getContactOptionsForStakeholder(
                                                        contact.stakeholderId
                                                      ).length === 0
                                                    ? "No contacts found"
                                                    : "Select Contact"
                                                }
                                                displayButton={
                                                  getContactOptionsForStakeholder(
                                                    contact.stakeholderId
                                                  ).length < 10
                                                }
                                                isDisabled={
                                                  isCompleted ||
                                                  !isStakeholderSelected ||
                                                  !contact.type ||
                                                  isLoadingContacts ||
                                                  contactsLoading ||
                                                  (!hasUpdatePermission &&
                                                    decodedToken?.roles?.some(
                                                      (role) =>
                                                        role.role_type !==
                                                        roleTypes.SUPER_ADMIN
                                                    ))
                                                }
                                                isClearable
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                maxMenuHeight={380}
                                                // disabled={isCompleted}
                                                formatOptionLabel={(option) => (
                                                  <div>
                                                    <div className="">
                                                      {option.label}
                                                    </div>
                                                    <small className="">
                                                      {option.phone}{" "}
                                                      {option?.email &&
                                                        " - " + option?.email}
                                                    </small>
                                                  </div>
                                                )}
                                                onMenuOpen={() =>
                                                  setOpenContactMenuIndex(index)
                                                }
                                                setOpenTypeMenuIndex={
                                                  setOpenTypeMenuIndex
                                                }
                                                setOpenSystemMenuIndex={
                                                  setOpenSystemMenuIndex
                                                }
                                                onMenuClose={() => {
                                                  if (!isAddingNewContact) {
                                                    setOpenContactMenuIndex(
                                                      null
                                                    );
                                                  }
                                                }}
                                                menuIsOpen={
                                                  openContactMenuIndex === index
                                                }
                                                closeMenuOnSelect={
                                                  !isAddingNewContact
                                                }
                                                components={{
                                                  MenuList:
                                                    CustomContactMenuList,
                                                }}
                                                hasCreateStakeholderPermission={
                                                  hasCreateStakeholderPermission
                                                }
                                                isSuperAdmin={isSuperAdmin}
                                                setIsAddingNewType={
                                                  setIsAddingNewType
                                                }
                                                isAddingNewContact={
                                                  isAddingNewContact
                                                }
                                                setIsAddingNewContact={
                                                  setIsAddingNewContact
                                                }
                                                newContactData={newContactData}
                                                setNewContactData={
                                                  setNewContactData
                                                }
                                                newContactError={
                                                  newContactError
                                                }
                                                setNewContactError={
                                                  setNewContactError
                                                }
                                                isSubmittingNewContact={
                                                  isSubmittingNewContact
                                                }
                                                handleSubmitNewContact={() =>
                                                  handleSubmitNewContact(
                                                    setFieldValue,
                                                    index,
                                                    contact.stakeholderId
                                                  )
                                                }
                                                handleCancelNewContact={
                                                  handleCancelNewContact
                                                }
                                                menuPlacement="auto"
                                                styles={{
                                                  ...customSelectStyles,
                                                  control: (
                                                    provided,
                                                    state
                                                  ) => ({
                                                    ...customSelectStyles.control(
                                                      provided,
                                                      state
                                                    ),
                                                    backgroundColor:
                                                      isStakeholderSelected
                                                        ? "#fff"
                                                        : "#f8f9fa",
                                                    cursor:
                                                      isStakeholderSelected
                                                        ? "pointer"
                                                        : "not-allowed",
                                                  }),
                                                }}
                                              />
                                              <ErrorMessage
                                                name={`contacts.${index}.contactId`}
                                                component="div"
                                                className="text-danger small mt-1"
                                              />
                                              {errors?.contacts?.[index]
                                                ?.contactId && (
                                                <span className="w-100 mt-1 small text-danger">
                                                  {
                                                    errors.contacts[index]
                                                      .contactId
                                                  }
                                                </span>
                                              )}
                                            </Col>

                                            <Col
                                              md={1}
                                              className="d-flex align-items-end pb-2"
                                            >
                                              {values.contacts.length > 1 && (
                                                <Button
                                                  variant="outline-danger"
                                                  size="sm"
                                                  className="d-flex align-items-center"
                                                  onClick={() => remove(index)}
                                                  title="Remove stakeholder"
                                                >
                                                  <RxCross2 size={18} />
                                                </Button>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                      );
                                    })}

                                  {!isCompleted &&
                                    (hasUpdatePermission ||
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type ===
                                          roleTypes.SUPER_ADMIN
                                      )) && (
                                      <Row className="mb-3">
                                        <Col md={12}>
                                          <Button
                                            type="button"
                                            variant="btn btn-primary"
                                            size="md"
                                            onClick={() => {
                                              push({
                                                stakeholderId: null,
                                                contactId: null,
                                                type: "",
                                              });
                                            }}
                                            className="d-flex align-items-center"
                                          >
                                            <FaPlus
                                              className="me-2"
                                              size={14}
                                            />
                                            Add More Stakeholder
                                          </Button>
                                        </Col>
                                      </Row>
                                    )}
                                </>
                              );
                            }}
                          </FieldArray>
                          {!isCompleted &&
                            (hasUpdatePermission ||
                              decodedToken?.roles?.some(
                                (role) =>
                                  role.role_type === roleTypes.SUPER_ADMIN
                              )) && (
                              <div className="d-flex justify-content-end mt-4">
                                <Button
                                  type="submit"
                                  variant="primary"
                                  className="me-2"
                                  disabled={
                                    isSubmitting ||
                                    isSubmitInProgress ||
                                    (!hasUpdatePermission &&
                                      decodedToken?.roles?.some(
                                        (role) =>
                                          role.role_type !==
                                          roleTypes.SUPER_ADMIN
                                      ))
                                  }
                                >
                                  Update
                                </Button>
                              </div>
                            )}
                        </Card.Body>
                      )}
                    </Card>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        <JobWorkOrders
          jobId={id}
          token={token}
          collapsedSections={collapsedSections}
          toggleCollapse={toggleCollapse}
        />
      </div>
    )}

      <Modal
        show={showConfirmModal}
        onHide={handleCancelCompleted}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="custom-modal-header d-flex relative">
          <Modal.Title>Mark Job as Completed?</Modal.Title>
          <button
            type="button"
            className="btn-close-svg"
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleCancelCompleted}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>

        <Modal.Body>
          <p>
            Marking this job as <strong>Completed</strong> will set all items to{" "}
            <strong>Installed</strong>. Are you sure all products and their
            quantities have been fully installed?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            onClick={handleConfirmCompleted}
            variant="btn btn-primary"
            disabled={isSubmitInProgress}
          >
            <i className="fas fa-check me-2" style={{ fontSize: "0.8rem" }}></i>
            Submit
          </Button>
          <Button variant="btn btn-danger" onClick={handleCancelCompleted}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {(hasUpdateJobItemStatusPermission ||
        hasViewJobProductReortPermission ||
        decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )) && (
        <JobProducts
          jobId={id}
          isCompleted={isCompleted}
          isCollapsed={collapsedSections.jobProducts}
          onToggleCollapse={() => toggleCollapse("jobProducts")}
        />
      )}
      {(hasBomCreatePermission ||
        hasBomViewPermission ||
        hasBomEditPermission ||
        hasBomDeletePermission ||
        hasBomCreatePRPermission ||
        hasBomPrintPermission ||
        decodedToken?.roles?.some(
          (role) => role.role_type === roleTypes.SUPER_ADMIN
        )) && (
        <JobBomsList
          jobId={id}
          isCompleted={isCompleted}
          isCollapsed={collapsedSections.jobBoms}
          onToggleCollapse={() => toggleCollapse("jobBoms")}
        />
      )}
    </>
  );
};

export default JobEdit;
